/* eslint-disable import/no-default-export */
import React from 'react';
import { connect } from 'react-redux';

import { Collapsible, CollapsibleProps } from './collapsible';
import { State } from 'app/gamma/src/modules';
import { toggleCollapsible } from 'app/gamma/src/modules/state/ui';

interface DispatchProps {
  readonly onToggleClick: () => void;
}

class CollapsibleContainer extends React.Component<
  CollapsibleProps & DispatchProps
> {
  render() {
    return <Collapsible {...this.props} />;
  }
}

function mapStateToProps(
  state: State,
  ownProps: CollapsibleProps,
): CollapsibleProps {
  const collapsibles = state.ui.collapsibles;
  const props = {
    ...ownProps,
    open: collapsibles[ownProps.categoryId]
      ? collapsibles[ownProps.categoryId].open
      : true,
  };

  return props;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function mapDispatchToProps(dispatch: any, ownProps: any): DispatchProps {
  return {
    onToggleClick() {
      dispatch(
        toggleCollapsible({
          id: ownProps.categoryId,
          open: ownProps.open,
        }),
      );
    },
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CollapsibleContainer);
